module.exports = __webpack_public_path__ + "img/ic_curve_arrow.17aa4eef.svg";